import { createRouter, createWebHashHistory } from 'vue-router'; 
import HomePage from './components/HomePage.vue';  // 新页面组件
import LivePage from './components/LivePage.vue';  // 新页面组件
import EventPage from './components/EventPage.vue';  // 新页面组件
import EventDetail from './components/EventDetail.vue'; //页面新组建

const routes = [
{
    path: '/:id?',
    name: 'home',
    component: HomePage,  // home页面的组件
    },
  {
    path: '/live',
    name: 'live',
    component: LivePage,  // live页面的组件
  },
  {
    path: '/event',
    name: 'eventList',
    component: EventPage,  // event页面的组件
  },
  {
    path: '/event/:item?',
    name: 'eventDetail',
    component: EventDetail,  // event页面的组件
  }
];

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),  // 使用 Hash 模式，避免历史模式问题
  routes,
});

export default router;
